import { UI, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InfoItem, InfoItemProps } from '../InfoItem';

export interface HighlightedInfosProps {
  infos: InfoItemProps[];
  note?: string;
}

export const HighlightedInfos: React.FC<HighlightedInfosProps> = ({ infos, note }) => {
  return (
    <VStack
      space={Spacing['stack.xxs']}
      px={Spacing['inline.xxs']}
      py={Spacing['stack.xxxs']}
      borderRadius={BoxBorder.heavy}
      backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
      <VStack space={Spacing['stack.nano']}>
        {infos.map((info, index) => (
          <InfoItem key={index} {...info} />
        ))}
      </VStack>
      {note && <UI.Text color="neutral.black">{note}</UI.Text>}
    </VStack>
  );
};
